import { render, staticRenderFns } from "./addPayFeeConfigDiscount.vue?vue&type=template&id=0d6d01f1&scoped=true"
import script from "./addPayFeeConfigDiscount.vue?vue&type=script&lang=js"
export * from "./addPayFeeConfigDiscount.vue?vue&type=script&lang=js"
import style0 from "./addPayFeeConfigDiscount.vue?vue&type=style&index=0&id=0d6d01f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d01f1",
  null
  
)

export default component.exports